<template>
  <div class="echartsBox">
    <div class="base-margin__bottom-10 base-flex">
      <!--  时间区间    -->
      <el-date-picker
        v-model="pickerValue"
        :clearable="false"
        :picker-options="pickerOptions"
        align="right"
        format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="changePickerValue"
      >
      </el-date-picker>
      <!--  时间颗粒    -->
      <el-select
        v-model="selectOptionsValue"
        :placeholder="$t('multiCloudCluster.echart.pleaseSelect')" class="base-margin__left-8 select_width"
        @change="changeSelectOptionsValue">
        <el-option
          v-for="item in selectOptions"
          v-show="item.show"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--&lt;!&ndash;   批次     &ndash;&gt;-->
      <!--<BatchIndex-->
      <!--  class="base-margin__left-8 select_width"-->
      <!--  ref="batchIndex"-->
      <!--  :subclusterId="Number(this.$route.query.id)"-->
      <!--  @filterSubclusterInstances="filterSubclusterInstances"-->
      <!--/>-->
    </div>
    <div class="echartsCollapse">
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="index in activeList.length" :key="index"
                          :name="activeList[index - 1].name" :title="activeList[index - 1].name">
          <echartsData :ref="activeList[index - 1].id"
                       :dayJsFormat="dayJsFormat"
                       :echartsId="activeList[index - 1].id"
                       :instanceInfo="instanceInfo"
                       :monitorType="monitorType"
                       :multiCloudPartitionInstanceId="multiCloudPartitionInstanceId"
                       :myLineCharDataList="myLineChartList[index - 1]"
                       :pickerValue="pickerValue"
                       :selectOptionsValue="selectOptionsValue"
                       :xAxisData="xAxisData"
          ></echartsData>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>

import dayjs from 'dayjs';
import {mapGetters, mapState} from 'vuex';
import {Message} from 'element-ui';
import {
  dateShortcuts,
  myLineChartListalicloud,
  myLineChartListHuaweicloud,
  myLineChartListVolcengine,
} from './constants/index';
import echartsData from './IndexView.vue';
import {debounce} from '@/common/utils/utils';


export default {
  name: 'echarts',
  components: {
    echartsData,
    // BatchIndex,
  },
  props: {
    multiCloudPartitionInstanceId: Number,
    monitorType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeList: [{
        name: this.$t('multiCloudCluster.echart.cpuMonitoring'),
        id: 'cpuMonitoring',
      }, {
        name: this.$t('multiCloudCluster.echart.memoryMonitoring'),
        id: 'memoryMonitoring',
      }, {
        name: this.$t('multiCloudCluster.echart.diskMonitoring'),
        id: 'diskMonitoring',
      }, {
        name: this.$t('multiCloudCluster.echart.networkMonitoring'),
        id: 'networkMonitoring',
      }],
      activeNames: [this.$t('multiCloudCluster.echart.cpuMonitoring'), this.$t('multiCloudCluster.echart.memoryMonitoring'),
        this.$t('multiCloudCluster.echart.diskMonitoring'), this.$t('multiCloudCluster.echart.networkMonitoring')],
      pickerValue: [],
      pickerOptions: {
        disabledDate: (time) => {
          const day1 = 180 * 24 * 3600 * 1000;
          const minTime = new Date().getTime() - day1;
          const maxTime = new Date().getTime();
          return time.getTime() < minTime || time.getTime() > maxTime;
        },
        shortcuts: dateShortcuts,
      },
      myLineChartList: [],
      selectOptionsValue: 10,
      selectOptions: [
        {
          value: 30,
          label: this.$t('multiCloudCluster.echart.thirtySeconds'),
          show: true,
        },
        {
          value: 60,
          label: this.$t('multiCloudCluster.echart.oneMinute'),
          show: true,
        },
        {
          value: 300,
          label: this.$t('multiCloudCluster.echart.fiveMinutes'),
          show: true,
        },
        {
          value: 1200,
          label: this.$t('multiCloudCluster.echart.twentyMinutes'),
          show: true,
        },
        {
          value: 3600,
          label: this.$t('multiCloudCluster.echart.oneHour'),
          show: true,
        },
        {
          value: 14400,
          label: this.$t('multiCloudCluster.echart.fourHours'),
          show: true,
        }, {
          value: 86400,
          label: this.$t('multiCloudCluster.echart.oneDay'),
          show: true,
        }],

      dayJsFormat: 'HH:mm',
      xAxisData: [],
      instanceInfo: {},
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {},

  created() {
    this.instanceInfo = this.$route.query;
    if (this.instanceInfo.type === 'volcengine') {
      this.myLineChartList = myLineChartListVolcengine;
    }
    if (this.instanceInfo.type === 'huaweicloud') {
      this.myLineChartList = myLineChartListHuaweicloud;
    }
    if (this.instanceInfo.type === 'aliyun') {
      this.myLineChartList = myLineChartListalicloud;
    }
  },


  mounted() {
    const currentProject = this.getCurrentProject();
    this.projectId = currentProject.id;
    // 子集群id

    // 默认获取一小时内的数据
    const startTime = dayjs().subtract(1, 'hour')
      .format('YYYY-MM-DD HH:mm:ss');
    const endTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
    this.pickerValue = [startTime, endTime];
    this.changePickerValue();
    const _this = this;
    window.onresize = function () {
      _this.echartsReSize();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },

  methods: {
    // 窗口改变
    echartsReSize() {
      debounce(() => {
        for (let i = 0; i < this.activeList.length; i++) {
          this.$refs[this.activeList[i].id][0].init('resize');
        }
      }, 200);
    },

    /**
     * 获取数据
     */
    getEchartsData() {
      for (let i = 0; i < this.activeList.length; i++) {
        this.$refs[this.activeList[i].id][0].getEchartsData(this.pickerValue, this.selectOptionsValue, this.subclusterId, this.batchIndex, this.activeList[i].id);
      }
    },

    changeSelectOptionsValue() {
      this.filterTimeMargin();
      this.getEchartsData();
    },

    // 批次
    // getAllSubclusterActivityCreateBatchIndex() {
    //   if (!this.$route.query.id) {
    //     return;
    //   }
    //   const data = {
    //     subclusterId: Number(this.$route.query.id),
    //   };
    //   postRequest('/api/eda/common/subcluster/getAllSubclusterActivityCreateBatchIndex', data).then((res) => {
    //     res.subclusterActivityIndexList.forEach((item) => {
    //       this.batchIndexOptions.push(item.createBatchIndex);
    //     });
    //   });
    // },

    /**
     * 切换时间， 格式化选择项
     */
    async changePickerValue() {
      if (!this.pickerValue) return Message.error(this.$t('multiCloudCluster.echart.pleaseSelectTimeRange'));
      const timeDiff = dayjs(this.pickerValue[1]).unix() - dayjs(this.pickerValue[0]).unix();
      // 时间不超过5分钟
      // if (timeDiff <= 300) {
      //   this.selectOptions.map((item) => {
      //     if (item.value < 300) {
      //       item.show = true;
      //     } else {
      //       item.show = false;
      //     }
      //   });
      //   this.selectOptionsValue = 10;
      //   this.dayJsFormat = 'HH:mm:ss';
      // }
      // 时间不超过1小时
      if (timeDiff > 300 && timeDiff <= 3600) {
        this.selectOptions.map((item) => {
          if (item.value <= 1200) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        if (this.instanceInfo.type === 'volcengine') {
          this.selectOptionsValue = 30;
        }
        if (this.instanceInfo.type === 'huaweicloud') {
          this.selectOptionsValue = 60;
        }
        if (this.instanceInfo.type === 'aliyun') {
          this.selectOptionsValue = 60;
        }
        this.dayJsFormat = 'HH:mm';
      }
      // 时间大于1小时 小于一天
      if (timeDiff > 3600 && timeDiff <= 86400) {
        this.selectOptions.map((item) => {
          if (item.value < 86400 && item.value >= 300) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.dayJsFormat = 'HH:mm';
        this.selectOptionsValue = 3600;
      }
      // 时间超过一天 不超过一周
      if (timeDiff > 86400 && timeDiff <= 604800) {
        this.selectOptions.map((item) => {
          if (item.value >= 3600) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.dayJsFormat = 'MM-DD';
        this.selectOptionsValue = 86400;
      }
      // 时间超过一周
      if (timeDiff > 604800) {
        this.selectOptions.map((item) => {
          if (item.value <= 3600) {
            item.show = false;
          } else {
            item.show = true;
          }
        });
        this.dayJsFormat = 'MM-DD';
        this.selectOptionsValue = 86400;
      }
      // 时间超过一个月
      if (timeDiff > 2592000) {
        this.selectOptions.map((item) => {
          if (item.value < 86400) {
            item.show = false;
          } else {
            item.show = true;
          }
        });
        this.dayJsFormat = 'MM-DD';
        this.selectOptionsValue = 86400;
      }

      await this.filterTimeMargin();
      await this.getEchartsData();
    },

    /**
     * 递归处理返回的时间
     */
    filterTimeMargin() {
      const startTime = dayjs(this.pickerValue[0]).unix();
      const endTime = dayjs(this.pickerValue[1]).unix();
      const xAxisData = [dayjs(this.pickerValue[0]).unix()];
      for (let i = 1; (i * this.selectOptionsValue) + startTime < endTime; i++) {
        xAxisData.push(((i * this.selectOptionsValue) + startTime));
      }
      xAxisData.push(endTime);
      this.xAxisData = xAxisData;
    },

    /**
     * 处理返回的标准时间
     * @param val 标准时间
     */
    disposeTime(val) {
      return dayjs(val).format('HH:mm');
    },

    /**
     * 处理echarts
     * @param i id
     */
    siteMyLineChart(value, i) {
      return `${value}${i}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.echartsCollapse {
  height: calc(100% - 20px);
  overflow: auto;

  //::v-deep .el-collapse-item__wrap {
  //  overflow: auto;
  //}
  //
  //::v-deep .el-collapse {
  //  overflow: auto;
  //}
}

.select_width {
  width: 240px !important;
}

::v-deep .el-collapse-item__header {
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0;
}


::v-deep .el-collapse-item__header:hover {
  background: rgb(236, 245, 255);
}

.echartsBox {
  height: 100%;
}


::v-deep .el-tabs__content {
  overflow: auto;
}
</style>
